import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {getLogoByHost} from '../../modules/config'

type LogoProps = {
  classname: string
  path?: string
}

const pathurl = getLogoByHost().logo

const Logo = ({classname, path = pathurl}: LogoProps) => {
  return <img alt='Logo' src={toAbsoluteUrl(path)} className={classname} />
}

export default Logo
